var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* ユーザ管理画面 */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import { user_params_init, radio_button_boolean_flg_init } from '../../Const';
import { scrollPageTop } from '../../Scroll';
import ResponseDialog from '../../molecules/ResponseDialog';
import LoadingModal from '../../organisms/LoadingModal';
import { nullChecker } from '../../Common';
import { useTranslation } from 'react-i18next';
import InputRadioButton from '../../molecules/maintenance/InputRadioButton';
import ResetButton from '../../atoms/Button';
import InputText from '../../molecules/maintenance/InputText';
import InputSelect from '../../molecules/maintenance/InputSelect';
import { se_role } from '../../Const';
var UserDetail = function () {
    var _a = useState(), options = _a[0], setOptions = _a[1];
    var _b = useState(false), is_loading = _b[0], setIsLoading = _b[1];
    // Ajaxリクエスト中フラグ
    var _c = useState(false), is_connecting = _c[0], setIsConnecting = _c[1];
    var _d = useState([]), menu_list = _d[0], setMenuList = _d[1];
    var _e = useState(user_params_init), user_info = _e[0], setUserInfo = _e[1];
    var _f = useState([]), messages = _f[0], setMessages = _f[1];
    var _g = useState(true), is_update = _g[0], setIsUpdate = _g[1];
    var _h = useState(false), is_complete = _h[0], setIsComplete = _h[1];
    var _j = useState(false), is_password_reset = _j[0], setIsPasswordReset = _j[1];
    var _k = useState(false), is_password_reset_complete = _k[0], setIsPasswordResetComplete = _k[1];
    // 言語
    var _l = useTranslation(), t = _l.t, i18n = _l.i18n;
    /**
     * データ取得用のパスを生成する
     *
     * URL末尾 ⇒ user_id ユーザID
     *
     * @return string データ取得用URL
     */
    var makePath = function () {
        var urls = location.pathname.split('/');
        var user_id = urls.pop();
        if (user_id === 'add') {
            setIsUpdate(false);
            return "/staff/maintenance/user/add_init";
        }
        else {
            setIsUpdate(true);
            return "/staff/maintenance/user/detail/init/" + user_id;
        }
    };
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getUserList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.get(makePath())];
                    case 1:
                        response = _a.sent();
                        setOptions(response.data.options);
                        setMenuList(response.data.menu_list);
                        setUserInfo(response.data.info);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading(false);
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Ajaxリクエスト
        getUserList();
    }, []);
    // 更新処理
    var handleClickUpdate = useCallback(function () {
        // クリックイベント
        var updateUser = function () { return __awaiter(void 0, void 0, void 0, function () {
            var urls, user_id, params, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        setMessages([]);
                        urls = location.pathname.split('/');
                        user_id = urls.pop();
                        params = {
                            user_id: user_id,
                            first_name: user_info.first_name,
                            last_name: user_info.last_name,
                            first_kana: user_info.first_kana,
                            last_kana: user_info.last_kana,
                            office_id: user_info.office_id,
                            role_id: user_info.role_id,
                            email: user_info.email,
                            del_flg: user_info.del_flg,
                            realsys_acc_flag: user_info.realsys_acc_flag,
                            password_email_destination: user_info.password_email_destination,
                        };
                        return [4 /*yield*/, axios.post('/staff/maintenance/user/update', params)];
                    case 1:
                        _a.sent();
                        setIsComplete(true);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2.message);
                        setMessages(error_2.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading(false);
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        updateUser();
    }, [user_info]);
    // 追加処理
    var handleClickAdd = useCallback(function () {
        // クリックイベント
        var updateUser = function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        setMessages([]);
                        params = {
                            first_name: user_info.first_name,
                            last_name: user_info.last_name,
                            first_kana: user_info.first_kana,
                            last_kana: user_info.last_kana,
                            office_id: user_info.office_id,
                            role_id: user_info.role_id,
                            email: user_info.email,
                            password: user_info.password,
                            del_flg: user_info.del_flg,
                            realsys_acc_flag: user_info.realsys_acc_flag,
                            password_email_destination: user_info.password_email_destination,
                        };
                        return [4 /*yield*/, axios.post('/staff/maintenance/user/create', params)];
                    case 1:
                        _a.sent();
                        setIsComplete(true);
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        console.error(error_3.message);
                        setMessages(error_3.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading(false);
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        updateUser();
    }, [user_info]);
    // パスワードリセット処理
    var handleClickPasswordReset = useCallback(function () {
        setIsPasswordReset(true);
    }, [is_password_reset]);
    // パスワードリセット処理
    var passwordReset = useCallback(function () {
        // クリックイベント
        var passwordResetUser = function () { return __awaiter(void 0, void 0, void 0, function () {
            var urls, user_id, params, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        setMessages([]);
                        urls = location.pathname.split('/');
                        user_id = urls.pop();
                        params = {
                            user_id: user_id,
                        };
                        return [4 /*yield*/, axios.post('/staff/maintenance/user/password_reset', params)];
                    case 1:
                        _a.sent();
                        setIsPasswordReset(false);
                        setIsPasswordResetComplete(true);
                        return [3 /*break*/, 4];
                    case 2:
                        error_4 = _a.sent();
                        console.error(error_4.message);
                        setMessages(error_4.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading(false);
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        passwordResetUser();
    }, [user_info, is_connecting]);
    // パスワードリセットキャンセル処理
    var passwordResetCancel = useCallback(function () {
        setIsPasswordReset(false);
    }, [is_password_reset]);
    // ユーザリストへ遷移
    var jumpUserList = useCallback(function () {
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/staff/maintenance/user");
    }, []);
    /**
     * 入力値変換処理
     */
    var handleChangeParams = useCallback(function (event) {
        var params = Object.assign({}, user_info);
        var target = nullChecker(event.target.id)
            ? event.target.id
            : event.target.name;
        var param = event.target.value;
        var set_targets = [];
        // targetが単一stringであるかをチェックする
        if (typeof target === 'string') {
            set_targets.push(target);
        }
        else {
            target.map(function (param) { return set_targets.push(param); });
        }
        // targetの個数分だけ繰り返しパラメータをセットする
        set_targets.map(function (target_param) {
            var set_param = Object.prototype.toString.call(param).slice(8, -1).toLowerCase() === 'boolean'
                ? param.toString()
                : typeof param === 'string'
                    ? param
                    : '';
            var key = target_param; // targetの型を明示的に指定
            params[key] = set_param;
        });
        // 権限がSE権限以外の場合は「パスワードメール送信先」を空にする
        if (target === 'role_id' && !se_role.includes(String(param))) {
            params['password_email_destination'] = '';
        }
        setUserInfo(params);
    }, [user_info]);
    /**
     * バリデーションメッセージを取得する
     * @param keys 取得キー
     * @returns バリデーションメッセージ
     */
    var getMessage = function (keys) {
        // バリデーションメッセージ取得
        var msg_list = [];
        keys.map(function (key) {
            messages === null || messages === void 0 ? void 0 : messages.map(function (msg) {
                if (msg.key === key) {
                    msg_list.push(msg.message);
                }
            });
        });
        // 重複を除去した配列を返す
        var msg_list_dupl = msg_list.filter(function (x, i, self) {
            return self.indexOf(x) === i;
        });
        // 配列内のメッセージを結合した値を返却
        return msg_list_dupl.join('\n');
    };
    // 新規登録の際に、R2Sアクセスフラグの初期値をfalseに設定する
    var realsys_acc_flag_radio_checked = user_info.realsys_acc_flag
        ? user_info.realsys_acc_flag
        : (user_info.realsys_acc_flag = 'false');
    /**
     * パスワードメール送信先を表示するかどうか
     * @param role_id string | number 権限
     * @returns boolean
     */
    var isPasswordEmailDestinationVisible = function (role_id) {
        return se_role.includes(String(role_id));
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { id: "detail" },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "detail-container" },
                        React.createElement("div", { className: "row my-2" },
                            React.createElement("div", { className: "col-md-6 col-sm-12" },
                                React.createElement(InputText, { id: "last_name", title: "\u59D3", class_name: "detail-form-input", value: user_info.last_name, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['last_name']), disabled: false })),
                            React.createElement("div", { className: "col-md-6 col-sm-12" },
                                React.createElement(InputText, { id: "first_name", title: "\u540D", class_name: "detail-form-input", value: user_info.first_name, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['first_name']), disabled: false }))),
                        React.createElement("div", { className: "row my-2" },
                            React.createElement("div", { className: "col-md-6 col-sm-12" },
                                React.createElement(InputText, { id: "last_kana", title: "\u59D3\u30AB\u30CA", class_name: "detail-form-input", value: user_info.last_kana, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['last_kana']), disabled: false })),
                            React.createElement("div", { className: "col-md-6 col-sm-12" },
                                React.createElement(InputText, { id: "first_kana", title: "\u540D\u30AB\u30CA", class_name: "detail-form-input", value: user_info.first_kana, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['first_kana']), disabled: false }))),
                        React.createElement("div", { className: "row my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-24" },
                                React.createElement(InputSelect, { id: "office_id", title: "\u6240\u5C5E\u90E8\u7F72", class_name: "detail-form-input-large", value: user_info.office_id, handleChange: handleChangeParams, options: options === null || options === void 0 ? void 0 : options.office, help_message: "", valid_message: getMessage(['office_id']), t: t }))),
                        React.createElement("div", { className: "row my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-24" },
                                React.createElement(InputSelect, { id: "role_id", title: "\u6A29\u9650", class_name: "detail-form-input-large", value: user_info.role_id, handleChange: handleChangeParams, options: options === null || options === void 0 ? void 0 : options.role, help_message: "", valid_message: getMessage(['role_id']), t: t }))),
                        React.createElement("div", { className: "row my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-24" },
                                React.createElement(InputText, { id: "email", title: "\u8077\u54E1\u756A\u53F7", class_name: "detail-form-input-large", value: user_info.email, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['email']), disabled: false }))),
                        is_update ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "row my-2" },
                                React.createElement("div", { className: "col-md-12 col-sm-24" },
                                    React.createElement("span", { className: "detail-criteria-head" }, "\u524A\u9664\u30D5\u30E9\u30B0"),
                                    React.createElement(InputRadioButton, { name: "del_flg", class_name: "radio-button", value_list: radio_button_boolean_flg_init, handleChange: handleChangeParams, checkedValue: user_info.del_flg }))),
                            React.createElement("div", { className: "row my-2" },
                                React.createElement("div", { className: "col-md-12 col-sm-24" },
                                    React.createElement("span", { className: "detail-criteria-head" }, "R2S\u30A2\u30AF\u30BB\u30B9\u30D5\u30E9\u30B0"),
                                    React.createElement("span", { className: "radio-button-group" },
                                        React.createElement(InputRadioButton, { name: "realsys_acc_flag", class_name: "radio-button", value_list: radio_button_boolean_flg_init, handleChange: handleChangeParams, checkedValue: user_info.realsys_acc_flag })))),
                            React.createElement("div", { className: "row my-2" },
                                React.createElement("div", { className: "col-md-12 col-sm-24" },
                                    React.createElement(ResetButton, { title: "\u30D1\u30B9\u30EF\u30FC\u30C9", class_name: "btn btn-main-color detail-form-input-small", value: "\u30EA\u30BB\u30C3\u30C8", handleClick: handleClickPasswordReset }))),
                            isPasswordEmailDestinationVisible(user_info.role_id) && (React.createElement("div", { className: "row my-2" },
                                React.createElement("div", { className: "col-md-6 col-sm-12" },
                                    React.createElement(InputText, { id: "password_email_destination", title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30E1\u30FC\u30EB\u9001\u4FE1\u5148", class_name: "detail-form-input", value: user_info.password_email_destination, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['password_email_destination']), disabled: false })))))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "row my-2" },
                                React.createElement("div", { className: "col-md-12 col-sm-24" },
                                    React.createElement("span", { className: "detail-criteria-head" }, "R2S\u30A2\u30AF\u30BB\u30B9\u30D5\u30E9\u30B0"),
                                    React.createElement("span", { className: "radio-button-group" },
                                        React.createElement(InputRadioButton, { name: "realsys_acc_flag", class_name: "radio-button", value_list: radio_button_boolean_flg_init, handleChange: handleChangeParams, checkedValue: realsys_acc_flag_radio_checked })))),
                            isPasswordEmailDestinationVisible(user_info.role_id) && (React.createElement("div", { className: "row my-2" },
                                React.createElement("div", { className: "col-md-6 col-sm-12" },
                                    React.createElement(InputText, { id: "password_email_destination", title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30E1\u30FC\u30EB\u9001\u4FE1\u5148", class_name: "detail-form-input", value: user_info.password_email_destination, handleChange: handleChangeParams, help_message: "", valid_message: getMessage(['password_email_destination']), disabled: false })))))),
                        React.createElement("div", { className: "row my-2" },
                            React.createElement("div", { className: "col-md-5 col-sm-10" },
                                React.createElement("div", { className: "detail-btn" },
                                    is_update && (React.createElement("button", { className: "btn btn-main-color", disabled: false, onClick: function () { return handleClickUpdate(); } }, "\u66F4\u65B0")),
                                    !is_update && (React.createElement("button", { className: "btn btn-main-color", disabled: false, onClick: function () { return handleClickAdd(); } }, "\u8FFD\u52A0")))),
                            React.createElement("div", { className: "col-md-5 col-sm-10" },
                                React.createElement("div", { className: "detail-btn" },
                                    React.createElement("button", { className: "btn btn-main-color", disabled: false, onClick: function () { return jumpUserList(); } }, "\u30AD\u30E3\u30F3\u30BB\u30EB")))))))),
        React.createElement(ResponseDialog, { is_confirm: true, show: is_complete, title: is_update ? '更新処理' : '追加処理', body: is_update ? '更新処理が完了しました。' : '追加処理が完了しました。', ClickCallBackConfirm: function () { return jumpUserList(); }, t: t }),
        React.createElement(ResponseDialog, { is_confirm: false, show: is_password_reset, title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8", body: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u3092\u884C\u3044\u307E\u3059\u3002\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B\uFF1F", ClickCallBackYes: function () { return passwordReset(); }, ClickCallBackNo: function () { return passwordResetCancel(); }, t: t }),
        React.createElement(ResponseDialog, { is_confirm: true, show: is_password_reset_complete, title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8", body: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u8A72\u5F53\u30E6\u30FC\u30B6\u306F\u6B21\u56DE\u30ED\u30B0\u30A4\u30F3\u6642\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059\u3002", ClickCallBackConfirm: function () { return jumpUserList(); }, t: t }),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('maintenance-user-detail')) {
    render(React.createElement(UserDetail, null), document.getElementById('maintenance-user-detail'));
}
